var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.5h-1.5V9H15V7.5zM10.5 7.5H9V9h1.5V7.5z",
    fill: "#45464F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15h-3.75v-1.5h.75A1.502 1.502 0 0018 12V9h1.5V7.5H18V6a1.502 1.502 0 00-1.5-1.5H15v-3h-1.5v3h-3v-3H9v3H7.5A1.502 1.502 0 006 6v1.5H4.5V9H6v3a1.502 1.502 0 001.5 1.5h.75V15H4.5A1.502 1.502 0 003 16.5v6h1.5v-6h15v6H21v-6a1.502 1.502 0 00-1.5-1.5zm-12-9h9v6h-9V6zm2.25 7.5h4.5V15h-4.5v-1.5z",
    fill: "#45464F"
  })));
}
export default SvgBot;